import { constants } from "../service";

export const getFaqFeedback = (id) => ({
  type: constants.GET_FAQ_FEEDBACK,
  id,
});

export const getFaqFeedbackSuccess = (data) => ({
  type: constants.GET_FAQ_FEEDBACK_SUCCESS,
  payload: data,
});

export const getFaqFeedbackError = (error) => ({
  type: constants.GET_FAQ_FEEDBACK_ERROR,
  error,
});

export const setFaqFeedback = (id, isGood) => ({
  type: constants.SET_FAQ_FEEDBACK,
  id,
  isGood,
});

export const setFaqFeedbackSuccess = (data) => {
  return {
    type: constants.SET_FAQ_FEEDBACK_SUCCESS,
    payload: data,
  };
};

export const setFaqFeedbackError = (error) => ({
  type: constants.SET_FAQ_FEEDBACK_ERROR,
  error,
});
